import { Routes } from '@angular/router';

export const inboxRoutes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./components/inbox-list/inbox-list.component').then(
        (m) => m.InboxListComponent,
      ),
  },
];
